import { TOKEN_REFRESH_FAILED } from "../constants/error";

export const tokenRefreshFailed = () => ({ type: TOKEN_REFRESH_FAILED });
